import cn from "classnames";
import {url} from "config";
import React from "react";
import sliders from "views/pages/about/sliders/sliders.module.sass";
import styles from "views/pages/about/sliders/teacher-class-slide/styles.module.sass";

const AcademyComfortSlide = () => {
    const backgroundStyles = {
        backgroundImage: `url(${url + "data/image-bank/ff3694a6-5cda-43ac-bc9f-230d727ee097.png"})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
    };

    return (
        <div className={sliders.wrapper} style={backgroundStyles}>
            <div className={sliders.content}>
                <div
                    className={cn({
                        [sliders.about]: true,
                        "mt-5": true,
                    })}
                >
                    <p
                        className={cn({
                            [sliders.title]: true,
                            [styles.title]: true,
                            "text-center": true,
                        })}
                    >
                        Комфортная среда
                    </p>
                    <p
                        className={cn({
                            [sliders.description]: true,
                            [styles.description]: true,
                            "text-center": true,
                            "w-100": true,
                        })}
                    >
                        Здесь нет комментариев и лайков, нет чатов и личных сообщений. <br /> Только
                        дружелюбная атмосфера и полезные знания!
                    </p>
                </div>
            </div>
        </div>
    );
};

AcademyComfortSlide.propTypes = {};

export default AcademyComfortSlide;
